<div class="py-3 flex items-center border-solid border-t border-neutral-300 px-2 bg-white text-sm fixed bottom-0 width-button-footer z-50">
  <ng-container *ngFor="let action of actionFooter">
    <button class="w-full bg-primary text-white font-semibold" (click)="submit()">{{labelAction}}</button>
  </ng-container>
</div>